import React from 'react';
import { motion } from 'framer-motion';

interface TapIndicatorProps {
  onClick: () => void;
  position?: 'bottom' | 'center' | 'inline';
  className?: string;
}

export const TapIndicator: React.FC<TapIndicatorProps> = ({ 
  onClick, 
  position = 'bottom',
  className = '' 
}) => {
  const positionClasses = {
    bottom: 'absolute bottom-8 left-1/2 -translate-x-1/2',
    center: 'absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2',
    inline: 'relative'
  };

  return (
    <motion.button
      className={`${positionClasses[position]} ${className} text-white/60 hover:text-white/80 transition-colors`}
      onClick={onClick}
      whileTap={{ scale: 0.95 }}
    >
      <motion.div
        className="flex flex-col items-center"
        animate={{ 
          opacity: [0.4, 1, 0.4],
          y: [0, 4, 0]
        }}
        transition={{ 
          duration: 1.5,
          repeat: Infinity,
          ease: "easeInOut"
        }}
      >
        <span className="text-2xl font-bold">▼</span>
      </motion.div>
    </motion.button>
  );
};